<template>
  <div 
    class="entry-popup"
    :style="{ height: unit === 'grade' ? '392px' : '302px' }">
    <div class="top">
      <v-icon @click="closeEntry">mdi-close</v-icon>
    </div>
    <h3 :style="{marginBottom: unit === 'grade' ? '32px' : '64px'}">{{ title }}</h3>
    <v-text-field
      v-if="unit !== 'grade'"
      ref="input"
      v-model="value"
      validate-on-blur
      :rules="rules"
      :placeholder="inputFieldDetails[unit].placeholder"
      :label="inputFieldDetails[unit].label"
    />
    <div v-else class="grade">
      <span>Select one emotion on a scale from 1-5</span>
      <div class="emoticons" :class="{ 'submitted': submitted && !value}">
        <div
          v-for="i in 5"
          :key="i"
          :class="[ i === value ? 'selected' : '', i === 3 ? 'middle' : '' ]">
        <img
          :src="imgInd(i)"
          @click="value = i" />
          <span :style="{ marginTop: i === 3 ? '5px' : ''}">{{ i }}</span>
        </div>
      </div>
    </div>
    <button
      class="submit"
      @click="submit"
      :disabled="$refs.input && !$refs.input.valid && unit !== 'grade'">
      <v-progress-circular
        v-if="loading"
        class="progress-loader"
        indeterminate
        color="#000"
        :size="24"
        :width="2"
      />
      <span v-else>
        Submit
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Emotions1 from '@/assets/project300/Emotions-1.png'
import Emotions2 from '@/assets/project300/Emotions-2.png'
import Emotions3 from '@/assets/project300/Emotions-3.png'
import Emotions4 from '@/assets/project300/Emotions-4.png'
import Emotions5 from '@/assets/project300/Emotions-5.png'
export default {
  name: 'EntryPopup',
  props: {
    title: {
      type: String
    },
    id: {
      type: Number
,   },
    unit: {
      type: String,
      default: 'reps'
    }
  },
  data() {
    return {
      loading: false,
      isFormValid: false,
      Emotions1: Emotions1,
      Emotions2: Emotions2,
      Emotions3: Emotions3,
      Emotions4: Emotions4,
      Emotions5: Emotions5,
      value: null,
      submitted: false,
      inputFieldDetails: {
        lbs: {
          label: 'Enter your weight (lbs)',
          placeholder: 'e.g. 150 lbs'
        },
        reps: {
          label: 'Number of reps',
          placeholder: 'e.g. 10'
        },
        mins: {
          label: 'Enter your time (e.g. 5m3s)',
          placeholder: 'Enter time'
        },
        grade: {
          label: 'Select one',
          placeholder: ''
        }
      }
    }
  },
  computed: {
    rules() {
      return [
        value => !!value || 'Required.',
        value => (value || '').length >= 2 || 'Min 2 characters',
        value => {
          const pattern = /^\d+$/
          const patternMin = /^\d{1,2}m\d{1,2}s$/;
          return this.unit === 'mins' ? patternMin.test(value) || 'Please enter the value in the ##m##s format' :
            pattern.test(value) || 'Entry must be a number'
        },
      ]
    }
  },
  methods: {
    ...mapActions(['updateUserMetrics']),
    closeEntry() {
      this.value = null
      this.$emit('close-entry')
    },
    imgInd(index) {
      switch(index) {
        case 1:
          return this.Emotions1
        case 2:
          return this.Emotions2
        case 3:
          return this.Emotions3
        case 4:
          return this.Emotions4
        case 5:
          return this.Emotions5
      }
    },
    async submit() {
      if (this.value) {
        try {
          this.loading = true
          await this.updateUserMetrics({id:this.id, date: Date(), value: this.value })
          this.closeEntry()
        } catch(e) {
          this.handleToolbarNotification({
            type: "warning",
            text: "Something went wrong! Please try again later.",
            isVisible: true,
          });
          setTimeout(() => {
            this.handleToolbarNotification({ isVisible: false });
          }, 3000);
        } finally {
          this.loading = false
        }
      } else {
        this.submitted = true
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/typography.scss";
.entry-popup {
  background: #100F0F;
  padding: 32px;
  display: flex;
  flex-flow: column;
  
  .top {
    display: flex;
    justify-content: end;
  }
  h3 {
    font-family: $app-special-font;
    font-size: 16px;
    line-height: 1.5;
    text-transform: uppercase;
    margin-bottom: 64px;
  }
  .grade {
    margin-bottom: 10px;
    .emoticons {
      position: relative;
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      gap: 2px;

      @media screen and (min-width: 600px) {
        gap: 16px;
      }
      
      div {
        display: flex;
        flex-flow: column;
        align-items: center;
        border-radius: 8px;
        cursor: pointer;
        border: 1px solid transparent;
        padding: 1px;
        transition: all 0.2s linear;
        padding: 8px;
        max-width: 100%;
        &:hover {
          background: rgba(221, 221, 221, 0.1);
        }
        &.selected {
          background: rgba(139, 223, 6, 0.1);
          border: 1px solid #8BDF061A;
        }
        &.middle {
          padding: 6px 10px;
          @media screen and (min-width: 600px) {
            padding: 9px 12px;
          }
          img {
            margin-top: 3px;
          }
        }
        img {
          width: 100%
        }
      }
      &.submitted {
        &::after {
          content: 'Please select your emotion!';
          width: 100%;
          position: absolute;
          bottom: -20px;
          left: 10px;
          color: #e53740;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
    }
  }

  .submit {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: black;
    height: 44px;
    border-radius: 23px;
    background: #8BDF06;
    width: 100%;
    text-transform: uppercase;
    margin-top: auto;
    &:focus-visible {
      outline: none;
    }
  }

  ::v-deep(.v-messages__message) {
    color: #e53740;
  }

  ::v-deep(.v-label) {
    text-transform: capitalize;
    margin-bottom: 10px;
    &.error--text {
      color: #e53740 !important;
    }
  }
}
</style>